import BaseRequest from './BaseRequest';

const schema = 'user';
/**
 * key base on host:port
 */
export default class UserRequest extends BaseRequest {
  /**
 * @param {Object} params
 * @param {string} params.pubkey
 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
 */
  userBalances(params) {
    const url = `${schema}/balances`;
    return this.get(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.pos
   * @param {string} params.count
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  loginHistories(params) {
    const url = `${schema}/login-histories`;
    return this.get(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.pos
   * @param {string} params.count
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  usersPaginate(params) {
    const url = `${schema}/paginate`;
    return this.get(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.pubkey
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  userInfo(params) {
    const url = `${schema}/info?pubkey=${params}`;
    return this.get(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.pubkey
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  userLoginHistory(params) {
    const url = `${schema}/login-history`;
    return this.get(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.pubkey
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  userListAddress(params) {
    const url = `${schema}/list-addresses/${params.pubkey}`;
    return this.get(url);
  }

  /**
   * @param {Object} params
   * @param {string} params.pos
   * @param {string} params.count
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  userSystemList(params) {
    const url = `${schema}/list-info`;
    return this.get(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.pubkey
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  userSystemInfo(params) {
    const url = `${schema}/info-by-pubkey`;
    return this.get(url, params);
  }

  lockUser(params) {
    const url = `${schema}/lock/${params.pubkey}`;
    return this.put(url);
  }

  unlockUser(params) {
    const url = `${schema}/unlock/${params.pubkey}`;
    return this.put(url);
  }
}
